import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Collapse, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Link, withRouter} from "react-router-dom";
import classname from "classnames";
import constants from "../../constants";
import {getAccountAlias, getAccountPath, getDashboardPath} from "../../helpers/Util";

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.adminWarning = localStorage.getItem("adminWarning");
        this.state = {
            adminModal: !!this.adminWarning
        };
    }

    toggleAdminModal = () => {
        this.setState(({
            adminModal: false
        }));
        localStorage.removeItem("adminWarning");
    };

    componentDidMount() {
        var matchingMenuItem = null;
        var ul = document.getElementById("navigation");
        var items = ul.getElementsByTagName("a");
        for (var i = 0; i < items.length; ++i) {
            if (this.props.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown = item => {
        item.classList.add("active");
        const parent = item.parentElement;
        if (parent) {
            parent.classList.add("active"); // li
            const parent2 = parent.parentElement;
            parent2.classList.add("active"); // li
            const parent3 = parent2.parentElement;
            if (parent3) {
                parent3.classList.add("active"); // li
                const parent4 = parent3.parentElement;
                if (parent4) {
                    parent4.classList.add("active"); // li
                    const parent5 = parent4.parentElement;
                    if (parent5) {
                        parent5.classList.add("active"); // li
                        const parent6 = parent5.parentElement;
                        if (parent6) {
                            parent6.classList.add("active"); // li
                        }
                    }
                }
            }
        }
        return false;
    };

    render() {
        const isTokenManagement = this.props.env.VARIANT === "TOKEN_MGMT";
        const {profile} = this.props;
        const isClient = profile && profile.group === "client";
        const permissions = profile && profile.permissions;

        const environmentOverrides = constants.environmentOverrides[this.props.env.VARIANT] || {};
        const showBds = !environmentOverrides.hideBd && permissions?.bd?.view;
        const showRias = !environmentOverrides.hideRia && permissions?.ria?.view;
        const showAgents = permissions?.agent?.view;
        const showClients = !isClient && permissions?.client?.view;
        const showAccounts = profile?.type !== "investor token plan" && (showBds || showRias || showAgents || showClients);
        const showWalletAccounts = profile?.type === "investor token plan" && showClients;
        const showTrade = !environmentOverrides.hideTrade && permissions?.trade?.view;
        const showRebalancer = !environmentOverrides.hideRebalancer && permissions?.rebalancer?.view;
        const showProducts = !environmentOverrides.hideProducts && permissions?.product?.view;
        const showOrderHistory = !environmentOverrides.hideOrderHistory && permissions?.product?.view;
        const showTrading = showTrade || showRebalancer || showProducts || showOrderHistory;
        const showChart = !environmentOverrides.hideChart && permissions?.chart?.view;
        const showRegulatory = !environmentOverrides.hideRegulatory && permissions?.regulatory?.view;
        const showTokenGrants = isTokenManagement && permissions?.tokenManagement?.view;
        const showTax = isTokenManagement && permissions?.tokenManagement?.tax;
        const showTransfer = isTokenManagement;
        const showStaking = this.props.env.STAKING_TOKENS && this.props.env.STAKING_TOKENS !== "null" && !(isClient && profile.custodianId === 2);
        const showGovernance = this.props.env.WORMHOLE_CONTRACT && this.props.env.WORMHOLE_CONTRACT !== "null";

        return (
            <React.Fragment>
                <div className="topnav">
                    <div className="container-fluid">
                        <nav className="navbar navbar-light navbar-expand-lg topnav-menu" id="navigation">
                            <Collapse isOpen={this.props.menuOpen} className="navbar-collapse" id="topnav-menu-content">
                                <ul className="navbar-nav">
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link arrow-none"
                                              to={getDashboardPath()}>
                                            <i className="bx bx-home-circle mr-2"/>Dashboard
                                        </Link>
                                    </li>

                                    {showAccounts && <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle arrow-none" to="/#"
                                              onClick={e => {
                                                  e.preventDefault();
                                                  this.setState({accountDropdown: !this.state.accountDropdown});
                                              }}>
                                            <i className={`bx ${isTokenManagement ? "bx-building" : "bx-group"} mr-2`}/>{getAccountAlias("account")}
                                            <div className="arrow-down"/>
                                        </Link>
                                        <div className={classname("dropdown-menu", {show: this.state.accountDropdown})}>
                                            {showBds && <Link to={`/${getAccountPath("bd")}`}
                                                              className="dropdown-item">{getAccountAlias("bd")}s</Link>}
                                            {showRias && <Link to={`/${getAccountPath("ria")}`}
                                                               className="dropdown-item">{getAccountAlias("ria")}s</Link>}
                                            {showAgents && <Link to={`/${getAccountPath("agent")}`}
                                                                 className="dropdown-item">{getAccountAlias("agent")}s</Link>}
                                            {showClients && <Link to={`/${getAccountPath("client")}`}
                                                                  className="dropdown-item">{getAccountAlias("client")}s</Link>}
                                        </div>
                                    </li>}

                                    {showWalletAccounts && <li className="nav-item dropdown">
                                        <Link className="nav-link arrow-none" to={`/${getAccountPath("client")}`}>
                                            <i className="bx bx-wallet mr-2"/>{getAccountAlias("client")}s
                                        </Link>
                                    </li>}

                                    {showTrading && <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle arrow-none" to="/#"
                                              onClick={e => {
                                                  e.preventDefault();
                                                  this.setState({ tradingDropdown: !this.state.tradingDropdown });
                                              }}>
                                            <i className="bx bx-file mr-2"/>Trading<div className="arrow-down"/>
                                        </Link>
                                        <div className={classname("dropdown-menu", { show: this.state.tradingDropdown })}>
                                            {showTrade && <Link to="/trade" className="dropdown-item">Trade</Link>}
                                            {showRebalancer && <Link to="/rebalance" className="dropdown-item">Rebalance</Link>}
                                            {showProducts && <Link to="/products" className="dropdown-item">Products</Link>}
                                            {showOrderHistory &&
                                                <Link to="/orders" className="dropdown-item">History</Link>}
                                        </div>
                                    </li>}

                                    {showTokenGrants &&
                                        <li className="nav-item dropdown">
                                            <Link className="nav-link arrow-none" to="/token-grants">
                                                <i className="bx bx-money mr-2"/>Token Grants
                                            </Link>
                                        </li>}

                                    {showTax &&
                                        <li className="nav-item dropdown">
                                            <Link className="nav-link arrow-none" to="/tax">
                                                <i className="bx bx-receipt mr-2"/>Tax
                                            </Link>
                                        </li>}

                                    {showTransfer && <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle arrow-none" to="/#"
                                              onClick={e => {
                                                  e.preventDefault();
                                                  this.setState({walletDropdown: !this.state.walletDropdown});
                                              }}>
                                            <i className={`bx bx-transfer mr-2`}/>Transfer
                                            <div className="arrow-down"/>
                                        </Link>
                                        <div className={classname("dropdown-menu", {show: this.state.walletDropdown})}>
                                            <Link to="/transfer#deposit" className="dropdown-item">Deposit</Link>
                                            <Link to="/transfer#withdraw" className="dropdown-item">Withdraw</Link>
                                        </div>
                                    </li>}

                                    {showStaking && <li className="nav-item dropdown">
                                        <Link className="nav-link arrow-none" to="/staking">
                                            <i className="bx bx-coin-stack mr-2"/>Staking
                                        </Link>
                                    </li>}

                                    {showGovernance && <li className="nav-item dropdown">
                                        <Link className="nav-link arrow-none" to="/governance">
                                            <i className="bx bx-shield mr-2"/>Governance
                                        </Link>
                                    </li>}

                                    {showChart && <li className="nav-item dropdown">
                                        <Link className="nav-link arrow-none" to="/chart">
                                            <i className="bx bx-line-chart mr-2"/>Chart
                                        </Link>
                                    </li>}

                                    {showRegulatory && <li className="nav-item dropdown">
                                        <Link className="nav-link arrow-none" to="/regulatory">
                                            <i className="bx bx-book mr-2"/>Regulatory
                                        </Link>
                                    </li>}

                                </ul>
                            </Collapse>
                        </nav>
                    </div>
                </div>
                <Modal isOpen={this.state.adminModal} role="dialog" size="md" autoFocus={true}
                       centered={true} id="feeModal">
                    <div className="modal-content">
                        <ModalHeader toggle={() => this.toggleAdminModal()}>WARNING</ModalHeader>
                        <ModalBody>
                            {this.adminWarning}
                        </ModalBody>
                        <ModalFooter>
                            <Button type="button" color="primary"
                                    onClick={this.toggleAdminModal}>Close</Button>
                        </ModalFooter>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {user, profile} = state.User;
    const {env} = state.Variables;
    return {user, profile, env};
};

export default withRouter(connect(mapStateToProps)(Navbar));
